import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grow md:flex-row justify-center pb-4 md:pb-0 md:flex md:justify-center" }

import type { MeQuery } from "@/api/queries/me.generated";
import { Routes } from "@/router";
import { ref } from "vue";
import NavBar from "./NavBar.vue";
import NavDropdown from "./NavDropdown.vue";
import NavLink from "./NavLink.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'NavBarStudent',
  props: {
    user: {}
  },
  emits: ["clickLogout"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const open = ref(false);
const onToggleNavigation = () => {
  open.value = !open.value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(NavBar, {
    open: open.value,
    onToggleNavigation: onToggleNavigation
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(NavLink, {
          to: { name: _unref(Routes).DASHBOARD }
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode("Dashboard", -1)
          ]))]),
          _: 1
        }, 8, ["to"]),
        _createVNode(NavLink, {
          to: { name: _unref(Routes).JOB_POSTING_SEARCH }
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode("Stelle finden", -1)
          ]))]),
          _: 1
        }, 8, ["to"]),
        _createVNode(NavLink, {
          to: { name: _unref(Routes).CHALLENGE_SEARCH }
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createTextVNode("Challenges | Mentorings", -1)
          ]))]),
          _: 1
        }, 8, ["to"]),
        _createVNode(NavLink, {
          to: { name: _unref(Routes).COMPANY_LIST }
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createTextVNode("Unternehmen entdecken", -1)
          ]))]),
          _: 1
        }, 8, ["to"])
      ]),
      _createVNode(NavDropdown, {
        text: __props.user?.firstName ?? ''
      }, {
        default: _withCtx(() => [
          _createVNode(NavLink, {
            to: { name: _unref(Routes).PROFILE },
            class: "border-b border-grey-2"
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode("Mein Profil", -1)
            ]))]),
            _: 1
          }, 8, ["to"]),
          _createElementVNode("button", {
            class: "block focus:bg-gray-200 focus:outline-none focus:shadow-outline focus:text-gray-900 hover:text-primary-1 bg-transparent md:mt-0 md:text-lg mt-2 px-4 py-2 text-sm transition-colors",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('clickLogout')))
          }, " Logout ")
        ]),
        _: 1
      }, 8, ["text"])
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})